import { render, staticRenderFns } from "./BindBenefits.vue?vue&type=template&id=05ec1a07&scoped=true"
import script from "./BindBenefits.vue?vue&type=script&lang=js"
export * from "./BindBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ec1a07",
  null
  
)

export default component.exports